import { getOfficeBrand } from "../../../../../actions/Utilities/OfficeBrand";
import { useQuery } from "react-query";

export default function useOfficeBrand() {
  //Fetching OfficeBrand Details
  const {data, isFetching} = useQuery("GetOfficeBrands", getOfficeBrand, {
    refetchOnWindowFocus: false,
  });

  return {data, isFetching};
}
